import { Moment, duration, utc } from 'moment';
import 'moment-timezone';

export class DateUtils {
  static toMoment(date: string | number): Moment {
    // Parse timestamp and return a date with a UTC offset that is the same as the local computer
    // See: https://momentjs.com/guides/#/parsing/local-utc-zone/
    return utc(date);
  }

  static toDateString(date: Moment): string {
    // Return the localized string representation of the date in the timezone of the user
    // See: https://momentjs.com/docs/#/displaying/
    return date.local().format('L');
  }

  static toISOString(date: Moment): string {
    // Backend can't handle Z as a timezone value so we have to replace that with +00:00
    return date.toISOString().replace(/Z$/, '+00:00');
  }

  static toDateTimeString(date: Moment): string {
    // Return the localized string representation of the date and time in the timezone of the user
    // See: https://momentjs.com/docs/#/displaying/
    return date.local().format('L LTS');
  }

  static toTimestampString(date: Moment): string {
    // Return the string representation of the date as a timestamp
    // See: https://momentjs.com/docs/#/displaying/
    return date.toISOString().replace(/Z$/, '+00:00');
  }

  static toUTCTimeString(date: Moment): string {
    // Return the UTC string representation of the date and time
    // See: https://momentjs.com/docs/#/parsing/utc/
    return date.utc().tz('UTC').format('L LT z');
  }

  static toDurationString(from: Moment, to: Moment) {
    return duration(to.diff(from, 'seconds', true), 'seconds').humanize(false);
  }
}
